import React from 'react';
import { Link } from "gatsby"

export default () => (
  <div className="section">
    <div className="container">
      <div className="cta-contained bg-primary-1">
        <div className="section-small cta-contained-content">
          <div className="content-width-medium">
            <h3 className="h1">Download App</h3>
            <div className="text-large"><strong>Download the WiseGuide to access all your programs in one destination.</strong><br /></div>
            <div className="margin-top"><Link to="/pricing/" className="button bg-white w-inline-block">
              <div>Get Started</div>
            </Link></div>
          </div>
        </div><img src="/images/5ddce53f016908197bb68816_summer-fun_t20_XQxaZG-p-1080.jpeg" width={612} alt="" className="cta-contained-image" />
      </div>
    </div>
  </div>
);
